import React from 'react'
import { Parser } from 'html-to-react';
import userCategoryName from "../../../../../constants/userCategory";

const VendorInvoiceAddress = (invoiceData) => {
    return (
        <>
            <div className="invo-from-to">
                <div className="invo-from-sing">
                    <div className="from-sing-head">From</div>
                    <div className="name-sing-head">{invoiceData.invoiceData ? (`${String(invoiceData.invoiceData.ven_inv_for.vendor_legalentity_name) === "null" ? "" : invoiceData.invoiceData.ven_inv_for.vendor_legalentity_name}` || `${String(invoiceData.invoiceData.ven_inv_for.vendor_name) === "null" ? "" : invoiceData.invoiceData.ven_inv_for.vendor_name}`) : (
                        <div
                            style={{
                                width: "180px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                            }}
                        />
                    )}</div>
                    <div className="addres-sing-head styll2">{invoiceData.invoiceData ? (invoiceData.invoiceData.ven_inv_for.address) : (
                        <div
                            style={{
                                width: "200px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                            }}
                        />
                    )}</div>
                    <div className="tele-sing-head styll2">{invoiceData.invoiceData ? (`Tel: ${invoiceData.invoiceData.ven_inv_for.mobile_no}`) : (
                        <div
                            style={{
                                width: "150px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                            }}
                        />
                    )}</div>
                    <div className="mail-sing-head styll2">{invoiceData.invoiceData ? (`Email: ${invoiceData.invoiceData.ven_inv_for.email}`) : (
                        <div
                            style={{
                                width: "200px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                            }}
                        />
                    )}</div>
                </div>
                {invoiceData.invoiceData && invoiceData.invoiceData.ven_inv_vendor && invoiceData.invoiceData.ven_inv_vendor.wx_company ?
                    (
                        <div className="invo-to-sing">
                            <div className="to-sing-head">To</div>
                            <div className="toname-sing-head">
                                {invoiceData.invoiceData ? (
                                    `${String(invoiceData.invoiceData.ven_inv_vendor.legal_entity_company_name) === "null" ? "" : invoiceData.invoiceData.ven_inv_vendor.legal_entity_company_name}` || `${String(invoiceData.invoiceData.ven_inv_vendor.wx_company) === "null" ? "" : invoiceData.invoiceData.ven_inv_vendor.wx_company}`
                                ) : (
                                    <div
                                        style={{
                                            width: "180px",
                                            height: "20px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "4px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                        }}
                                    />
                                )}
                            </div>
                            <div className="toaddres-sing-head styll2">
                                <pre style={{ fontFamily: 'halyard-display' }}>
                                    {invoiceData.invoiceData ? (
                                        Parser().parse(invoiceData.invoiceData.ven_inv_vendor.address)
                                    ) : (
                                        <div
                                            style={{
                                                width: "200px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    )}
                                </pre>
                            </div>
                            <div className="totele-sing-head styll2">{invoiceData.invoiceData ? (`Tel: ${invoiceData.invoiceData.ven_inv_vendor.mobile_no}`) : (
                                <div
                                    style={{
                                        width: "150px",
                                        height: "20px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</div>
                            <div className="tomail-sing-head styll2">{invoiceData.invoiceData ? (`Email: ${invoiceData.invoiceData.ven_inv_vendor.email}`) : (
                                <div
                                    style={{
                                        width: "200px",
                                        height: "20px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</div>
                        </div>
                    ) : (
                        <div className="invo-to-sing">
                            <div className="to-sing-head">To</div>
                            <div className="toname-sing-head">
                                <pre style={{ fontFamily: 'halyard-display' }}>
                                    {invoiceData.invoiceData ? (invoiceData.invoiceData.ven_inv_from.address) : (
                                        <div
                                            style={{
                                                width: "200px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    )}
                                </pre>
                            </div>
                            <div className="toaddres-sing-head styll2">{invoiceData.invoiceData ? (invoiceData.invoiceData.ven_inv_from.address) : (
                                <div
                                    style={{
                                        width: "200px",
                                        height: "20px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</div>
                            <div className="totele-sing-head styll2"> {invoiceData.invoiceData ? (`Tel: ${invoiceData.invoiceData.ven_inv_from.mobile_no}`) : (
                                <div
                                    style={{
                                        width: "150px",
                                        height: "20px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</div>
                            <div className="tomail-sing-head styll2"> {invoiceData.invoiceData ? (`Email: ${invoiceData.invoiceData.ven_inv_from.email}`) : (
                                <div
                                    style={{
                                        width: "200px",
                                        height: "20px",
                                        backgroundColor: "#e5e7eb",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</div>
                        </div>
                    )}
            </div>
            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.5;
                    }
                }
            `}</style>
        </>
    )
}

export default VendorInvoiceAddress